// src/pages/ClientPanel/Products/ProductsModal/style.ts

import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 30px 32px 40px;
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;

  h2 {
    color: #202020;
    font-size: 22px;
    font-weight: 600;
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 28px; /* Um pouco maior */

  border-radius: 50%; /* Deixa redondo */
  transition: background 0.2s ease-in-out;

  &:hover {
    background-color: #f0f0f0; /* Fundo redondo ao passar mouse */
  }

  img {
    width: 24px;
    height: 24px;
  }
`;


export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 999px;
  background-color: #f0f0f0;
  font-size: 15px;
  color: #333;
  box-sizing: border-box;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 158, 247, 0.3);
  }

  &::placeholder {
    color: #777;
  }
`;

export const SelectStyled = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 999px;
  background-color: #f0f0f0;
  font-size: 15px;
  color: #333;
  box-sizing: border-box;
  appearance: none;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns="http://www.w3.org/2000/svg" width="292.4" height="292.4"%3E%3Cpath fill="%23999" d="M287 69.4a17.6 17.6 0 0 0-13-5.4H18.4c-6.5 0-12.3 3.2-15.8 8.1-3.5 4.9-3.4 11.6.1 16.5l130.4 142.7c3.5 3.8 8.3 6 13.3 6s9.8-2.2 13.3-6L287 85.9c3.6-4.9 3.6-11.6.1-16.5z"/%3E%3C/svg%3E');
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 10px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 158, 247, 0.3);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
`;

export const ActionButton = styled.button`
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: 999px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease-in-out;

  img {
    width: 18px;
    height: 18px;
  }
`;

export const ImportButton = styled(ActionButton)`
  background-color: transparent;
  color: #0D99FF;
  border: none;

  img {
    filter: brightness(0) saturate(100%) invert(42%) sepia(92%) saturate(749%) hue-rotate(176deg) brightness(97%) contrast(101%);
  }

  &:hover {
    background-color: #F0F2F5;
  }
`;


export const CancelButton = styled(ActionButton)`
  background-color: white;
  color: #0D99FF;
  border: 1px solid #0D99FF;

  &:hover {
    background-color: #f5f5f5;
    border-color: #c0c0c0;
  }
`;

export const SaveButton = styled(ActionButton)`
  background-color: #0D99FF;
  color: white;

  &:hover {
    background-color: #0D99FF;
  }
`;

export const Tag = styled.span`
  background-color: white;
  border: 1px solid #dcdcdc;
  color: #333;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 4px;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const GradContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

export const GradButton = styled.button<{ selected: boolean }>`
  background-color: white;
  color: ${props => (props.selected ? '#009ef7' : '#333')};
  padding: 8px 16px;
  border: 1px solid ${props => (props.selected ? '#009ef7' : '#dcdcdc')};
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  font-weight: ${props => (props.selected ? '500' : 'normal')};

  &:hover {
    background-color: ${props => (props.selected ? '#e6f4fc' : '#f0f0f0')};
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px; /* Novo: espaçamento entre nome do produto e este bloco */
  margin-bottom: 20px;

  & > div {
    flex: 1;
  }
`;


export const SuggestionsContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

export const SuggestionItem = styled.li`
  padding: 10px 16px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
